/* eslint no-restricted-syntax: "off", guard-for-in: "off" */

export default function (errors) {
  const errorMessages = [];
  const validationErrors = [];
  const stripeErrors = [];
  const stripeConnectionErrors = [];

  // typeof only detects primitive strings. Strings created as a String object will typeof as objects. The latter check
  // will catch those.
  if (!Array.isArray(errors) && (typeof errors === 'string' || typeof errors === 'object') ) {
    if (errors === 'Failed to fetch' || errors.message == 'Failed to fetch') {
      errorMessages.push('Network error - cannot reach the server. Please check your connection and try again.');
    } else {
      errorMessages.push(errors);
    }
  }

  if (Array.isArray(errors)) {
    errors.forEach((error) => {
      if (typeof error.message === 'string') {
        if (error.message === 'Failed to fetch') {
          errorMessages.push('Network error - cannot reach the server. Please check your connection and try again.');
        } else if (error.code === 'stripe_error') {
          stripeErrors.push(error.message);

        } else if (error.code === 'stripe_connection_error') {
          stripeConnectionErrors.push(error.message);
        } else {
          errorMessages.push(error.message);
        }

      } else if (typeof error.message === 'object') {
        for (const message in error.message) {
          if (typeof error.message[message] === 'string') {
            if (error.message[message] === 'Failed to fetch') {
              errorMessages.push('Network error - cannot reach the server. Please try again soon.');
            } else {
              errorMessages.push(error.message[message]);
            }
          } else if (error.code === 'validation_error' && typeof error.message[message] === 'object') {
            validationErrors[message] = [];

            for (const detailedMessage in error.message[message]) {
              validationErrors[message][detailedMessage] = error.message[message][detailedMessage];
            }
          } else if (error.code === 'stripe_error' && typeof error.message[message] === 'object') {
            stripeErrors[message] = [];

            for (const detailedMessage in error.message[message]) {
              stripeErrors[message][detailedMessage] = error.message[message][detailedMessage];
            }
          } else if (error.code === 'stripe_connection_error' && typeof error.message[message] === 'object') {
            stripeConnectionErrors[message] = [];

            for (const detailedMessage in error.message[message]) {
              stripeConnectionErrors[message][detailedMessage] = error.message[message][detailedMessage];
            }
          }

        }
      }
    });
  }

  return {
    errorMessages,
    validationErrors,
    stripeErrors,
    stripeConnectionErrors
  };
}



// WEBPACK FOOTER //
// ./src/modules/geterrors.js